import { render, staticRenderFns } from "./ConTent.vue?vue&type=template&id=23f0cf59&scoped=true"
import script from "./ConTent.vue?vue&type=script&lang=js"
export * from "./ConTent.vue?vue&type=script&lang=js"
import style0 from "./ConTent.vue?vue&type=style&index=0&id=23f0cf59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f0cf59",
  null
  
)

export default component.exports